import { useEffect, useState } from "react";
import axios from "axios";
import "./contract.scss";
import SignatureCanvas from "react-signature-canvas";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import party from "party-js";
import Tick from "../animations/Tick";
import { decryptData } from "../../utils/cryptoUtils";
import moment from "moment";
import Footer from "../Footer";
import Logo from "../images/logo.webp";

party.settings.debug = false;
party.resolvableShapes["logo"] =
  `<img width="32px" src="https://i.pinimg.com/originals/eb/e4/9c/ebe49c9609b15a98b84de9f2b057b16f.png"/>`;

const confettiSettings = {
  shapes: [
    "square",
    "rectangle",
    "roundedSquare",
    "circle",
    "roundedRectangle",
    "star",
    // "logo"
  ],
  // The amount of confetti particles that should be emitted.
  count: party.variation.range(80, 200),
  // The amount of spread that is applied to the emission angle. Note that the default angle points upwards.
  spread: 30,
  // The initial speed that the confetti particles are emitted with.
  speed: party.variation.range(50, 600),
  // The initial size that the confetti particles are emitted with.
  size: party.variation.skew(1, 0.8),
  // The initial rotation that the confetti particles are emitted with.
  rotation: () => party.random.randomUnitVector().scale(180),
  // The initial color that particles are emitted with.
  color: () =>
    party.random.pick([
      party.Color.fromHex("#238446"),
      party.Color.fromHex("#1D7DB2"),
      party.Color.fromHex("#FFC800"),
      party.Color.fromHex("#FFFFFF"),
    ]),
};

export default function Contract() {
  const [data, setData] = useState({});
  const [signature, setSignature] = useState("");
  const [tick, setTick] = useState(false);
  const navigate = useNavigate();
  const [dbid, setDbid] = useState("");
  const [errorAlert, setErrorAlert] = useState(false);
  const [managerContract, setManagerContract] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [breaks, setBreaks] = useState(false);
  const [isWarehouse, setIsWarehouse] = useState(false);
  const [isStrathclyde, setIsStrathclyde] = useState(false);
  const [probationDuration, setProbationDuration] = useState("");
  const [noDetails, setNoDetails] = useState(false);
  const [ip, setIp] = useState("");
  const [promotion, setPromotion] = useState(false);
  // const url="http://10.0.0.174:4030"
  const url = process.env.REACT_APP_HR_API_URL;
  document.title = "Onboarding | Contract";

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get("id");
    setDbid(userId);

    if (userId.includes("pr")) {
      setPromotion(true);
    }
    axios
      .get(`${url}/onBoard/new-start/${userId}`)
      .then((res) => {
        //console.log("request answer:", res.data);
        if (
          res.data.position.toLowerCase().includes("manager") ||
          res.data.company === "Head Office" ||
          (res.data.company === "Nitro Solutions 23 Ltd" &&
            res.data.position !== "Warehouse Assistant" &&
            res.data.position !== "Warehouse Packer")
        ) {
          setManagerContract(true);
          setBreaks(true);
        }
        if (
          res.data.position.includes("Supervisor") ||
          res.data.position.includes("Leader") ||
          res.data.companyName.includes("RTMS")
        ) {
          setBreaks(true);
        }

        if (
          res.data.position == "Warehouse Assistant" ||
          res.data.position == "Warehouse Packer"
        ) {
          setIsWarehouse(true);
        }

        if (
          res.data.companyName.toLowerCase().includes("rt st james ltd") &&
          !res.data.position.toLowerCase().includes("manager") &&
          !res.data.position.toLowerCase().includes("supervisor")
        ) {
          setIsStrathclyde(true);
        }

        var compAddress = "";

        if (
          res.data.company === "Head Office" ||
          res.data.company === "Nitro Solutions 23 Ltd"
        ) {
          if (
            res.data.position.toLowerCase().includes("warehouse") ||
            res.data.position.toLowerCase().includes("operative") ||
            res.data.position == "Baking Assistant"
          ) {
            compAddress = "70 Johnstone Avenue, Hillington, Glasgow, G52 4JT";
          } else {
            compAddress =
              "St James Church, 30 Underwood Road, Paisley, PA3 1TL";
          }
        } else {
          compAddress = `${res.data.addressLine1}, ${res.data.city}, ${res.data.postcode}`;
        }

        if (res.data._id) {
          setData(res.data);
        } else {
          //console.log(res.data);
          let hourly;
          if (res.data.salaryHourly) {
            hourly = res.data.salaryHourly;
          } else if (res.data.salaryYearly) {
            hourly = res.data.salaryYearly;
          }
          //calculates duration of the probation

          let probation = moment(res.data.probationDate, "YYYY-MM-DD");
          let startDate = moment(res.data.startDate, "YYYY-MM-DD");

          let probationTime = probation.diff(startDate, "months");
          setProbationDuration(probationTime);
          let data = {
            company: res.data.companyName,
            address: compAddress,
            firstName: decryptData(
              res.data.firstName,
              process.env.REACT_APP_EMP_KEY,
            ),
            middleName: null,
            lastName: decryptData(
              res.data.lastName,
              process.env.REACT_APP_EMP_KEY,
            ),
            startDate: new Date(res.data.startDate).toLocaleDateString("en-GB"),
            probationDate: new Date(res.data.probationDate).toLocaleDateString(
              "en-GB",
            ),

            promotionStart: res.data.promotionStart,

            position: res.data.position,
            hourly: hourly,
            noticePeriod: res.data.noticePeriod,
            contract: res.data.contractedHours,
            shiftHours: parseFloat(res.data.contractedHours) >= 45 ? 9 : 8,
            breakAllowance: res.data.breakAllowance,
            salaryType: res.data.salaryType,
          };

          if (res.data.probation) {
            data.probationDate = res.data.probation;
          }

          if (res.data.middleName != null) {
            data.middleName = decryptData(
              res.data.middleName,
              process.env.REACT_APP_EMP_KEY,
            );
          }
          setData(data);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err");
        if (err.response.status === 404) {
          setNoDetails(true);
        }
      });

    axios
      .get("https://api.ipify.org/?format=json")
      .then((res) => {
        setIp(res.data.ip);
      })
      .catch((err) => {
        console.log(`Could not get IP Address`);
      });
  }, []);

  const sign = () => {
    document.getElementById("sign__btn").style.display = "none";
    if (signature.isEmpty()) {
      setMessage("Please sign the contract");
      setSeverity("error");
      setErrorAlert(true);
      setTimeout(() => {
        setErrorAlert(false);
        setMessage("");
        setSeverity("");
        document.getElementById("sign__btn").style.display = "flex";
      }, 3500);
    } else {
      const signatureData = signature.getTrimmedCanvas().toDataURL("img/png");
      let details = {
        id: dbid,
        signature: signatureData,
        ipAddress: ip,
      };
      sessionStorage.setItem("site", JSON.stringify(data.company));
      sessionStorage.setItem("staff", JSON.stringify(data.firstName));
      axios
        .post(`${url}/onBoard/new-start/contractReceived`, details)
        .then((res) => {
          setTick(true);
          setTimeout(() => {
            setTick(false);
            party.confetti(
              document.getElementById("sign__btn"),
              confettiSettings,
            );
            setTimeout(() => {
              navigate(`/contract-completed`);
            }, 500);
          }, 2500);
        })
        .catch((err) => {
          setMessage(err.response.data.error? `${err.response.data.error}`:"Something went wrong, please try again");
          setSeverity("error");
          setErrorAlert(true);
          setTimeout(() => {
            setErrorAlert(false);
            setMessage("");
            setSeverity("");
            document.getElementById("sign__btn").style.display = "flex";
          }, 3500);
        });
    }
  };

  return (
    <>
      <main className="contract">
        {!noDetails ? (
          <>
            <h1 style={{ textAlign: "center" }}>
              STATEMENT OF MAIN TERMS OF EMPLOYMENT
            </h1>
            <p
              className="statement"
              style={{ textAlign: "center", fontStyle: "italic" }}
            >
              This Statement of Main Terms of Employment is provided in
              accordance with section 1 of the Employment Rights Act 1996 and
              sets out the principal terms and conditions of your employment.
            </p>
            <p
              className="statement"
              style={{ textAlign: "center", fontStyle: "italic" }}
            >
              Together with the Employee Handbook (which does not form part of
              your contract unless expressly stated), this document forms part
              of your Contract of Employment.
            </p>
            <p
              className="statement"
              style={{ textAlign: "center", fontStyle: "italic" }}
            >
              Where there is any inconsistency between this Statement and any
              other document, the terms of this Statement shall prevail unless
              expressly stated otherwise.
            </p>
            <p
              className="statement"
              style={{ textAlign: "center", fontStyle: "italic" }}
            >
              This Statement relates to the employment of:
            </p>

            <h1 style={{ textAlign: "center" }}>{data.company}</h1>
            <h2 style={{ textAlign: "center" }}>{data.address}</h2>
            <p className="p__tag" style={{ textAlign: "center" }}>
              employs
            </p>
            <h1 style={{ textAlign: "center" }}>
              {data.firstName} {data.middleName} {data.lastName}
            </h1>

            <section className="contract">
              <p className="p__tag">
                This Agreement sets out the principal terms and conditions of
                your employment with <strong>{data.company}</strong> and
                satisfies the requirements of section 1 of the Employment Rights
                Act 1996 (as amended).
              </p>

              <h3>job title and duties</h3>
              {!promotion ? (
                <p className="p__tag">
                  You are employed as an <b>{data.position}</b> and your duties
                  will be as advised by your manager, or any other manager
                  authorised by the company. You will carry out the duties and
                  responsibilities associated with this role, together with any
                  other duties that are reasonable and consistent with your
                  skills, experience and level of responsibility, as may be
                  assigned by the Company from time to time. You agree to carry
                  out your duties with reasonable skill, care and diligence and
                  to act at all times in the best interests of the Company.
                </p>
              ) : (
                <p className="p__tag">
                  You were made <b>{data.position}</b> from{" "}
                  <b>
                    {moment(data.promotionStart, "YYYY-MM-DD").format(
                      "DD/MM/YYYY",
                    )}
                  </b>{" "}
                  and your duties will be as advised by your manager, or any
                  other manager authorised by the company. You will carry out
                  the duties and responsibilities associated with this role,
                  together with any other duties that are reasonable and
                  consistent with your skills, experience and level of
                  responsibility, as may be assigned by the Company from time to
                  time. You agree to carry out your duties with reasonable
                  skill, care and diligence and to act at all times in the best
                  interests of the Company.
                </p>
              )}
              <p className="p__tag">
                The Company reserves the right to make reasonable changes to
                your duties and responsibilities to meet the operational needs
                of the business. Such changes will not fundamentally alter the
                nature of your employment.
              </p>
              <p className="p__tag">
                Where reasonably required, you may be asked to provide support,
                assistance or temporary cover at another Company location or
                within another department, provided that this is appropriate to
                your role and business needs.
              </p>

              <h3>start of employment</h3>
              {!promotion ? (
                <p className="p__tag">
                  Your employment began on <b>{data.startDate}</b>. No previous
                  employment counts as part of your period of continuous
                  employment. You will serve a probationary period of six (6)
                  months that will be reviewed on{" "}
                  <b>
                    {moment(
                      data.probationDate,
                      ["DD/MM/YYYY", "YYYY-MM-DD"],
                      true,
                    ).format("DD/MM/YYYY")}
                  </b>
                  .
                </p>
              ):(
                <p className="p__tag">
                  Your employment began on <b>{data.startDate}</b>. This counts as part of your previous continuous employment. You will serve a probationary period of six (6)
                  months that will be reviewed on{" "}
                  <b>
                    {moment(
                      data.probationDate,
                      ["DD/MM/YYYY", "YYYY-MM-DD"],
                      true,
                    ).format("DD/MM/YYYY")}
                  </b>
                  .
                </p>
              )}

              <h3>place of work</h3>
              <p className="p__tag">
                You will normally be required to work at <b>{data.address}</b>.
                You may, however, be required to work at any other premises
                operated by the Company, or any associated company within the
                Group, either on a temporary or permanent basis, where this is
                reasonably required to meet the operational needs of the
                business.
              </p>
              <p className="p__tag">
                Where practicable, the Company will provide reasonable notice of
                any change to your place of work. However, you acknowledge that
                there may be occasions where little or no notice can be given
                due to unforeseen operational requirements, including but not
                limited to sickness absence, annual leave cover, training,
                business demands or emergency situations.
              </p>
              <p className="p__tag">
                When exercising its discretion under this clause, the Company
                will act reasonably and will take into account, where
                practicable, the distance involved, your personal circumstances
                and the operational requirements of the business.
              </p>
              <p className="p__tag">
                You will not be required to work outside the United Kingdom.
              </p>
              <p className="p__tag">
                Where your role reasonably requires travel between Company
                locations or to other business-related locations during your
                working hours, you will be expected to do so. You must hold and
                maintain any licence or qualification required for your role and
                comply with the Company's policies relating to driving, vehicle
                use and business travel where applicable.
              </p>

              <h3>hours of work</h3>
              <p className="p__tag">
                Your normal contractual hours of work are <b>{data.contract}</b>{" "}
                hours per week, to be worked over up to five days out of seven.
              </p>
              <p className="p__tag">
                Your normal working pattern and start and finish times will be
                determined by the Company in accordance with the operational
                requirements of the business. You will be notified of your
                working hours through the Company's rota or scheduling
                arrangements.
              </p>
              <p className="p__tag">
                Due to the nature of the Company's business, you may be required
                to work different shifts, weekends, evenings and public or bank
                holidays where appropriate to your role.
              </p>
              <p className="p__tag">
                You are entitled to the statutory minimum rest breaks in
                accordance with the Working Time Regulations 1998. Where you
                work more than six hours in a working day, you will normally be
                entitled to an unpaid rest break of at least{" "}
                <b>{data.breakAllowance}</b> minutes, unless a longer break is
                provided under Company policy. Where you are under the age of
                18, you will be entitled to an uninterrupted unpaid rest break
                of at least 30 minutes where you work for more than four and a
                half hours in a working day, or such greater entitlement as may
                be required by law.
              </p>
              <p className="p__tag">
                You may be required to work reasonable additional hours, where
                authorised, to meet the operational needs of the business.
                Unless expressly agreed otherwise, any authorised additional
                hours will be paid at your normal hourly rate.
              </p>
              <p className="p__tag">
                The Company reserves the right to vary your working hours, shift
                patterns and working arrangements, provided any changes are
                reasonable and made in accordance with the operational needs of
                the business.
              </p>

              {isStrathclyde && (
                <>
                  <h3>guaranteed minimum of 8 hours (non-term time)</h3>
                  <p className="p__tag">
                    The Employee is employed on a part-time basis and is
                    guaranteed a minimum of 8 hours' work per week. The
                    Employee's actual working hours may vary from week to week
                    in accordance with the operational needs of the business.
                    The Employee acknowledges that the Company experiences
                    periods of reduced activity, particularly during non-term
                    time or other periods of lower demand ("Quiet Periods").
                    During such periods, the Company may temporarily reduce the
                    Employee's working hours, provided that the minimum
                    guaranteed hours of 8 hours per week are maintained, where
                    this is reasonably necessary to ensure the continued
                    operation of the business.
                  </p>
                  <p className="p__tag">
                    Any variation to working hours will be applied fairly and
                    proportionately and will be communicated to the Employee
                    with reasonable notice. As the Employee is paid on an hourly
                    basis, remuneration will vary in line with the hours worked.
                    The Company will use reasonable endeavours to increase the
                    Employee's working hours when business demand allows.
                  </p>
                </>
              )}

              <h3>other employment</h3>
              <p className="p__tag">
                If, at the commencement of your employment or at any time during
                your employment with the Company, you undertake or intend to
                undertake any additional employment, self-employment or other
                business activity, you must notify the Company in writing.
              </p>
              <p className="p__tag">
                The Company reserves the right to discuss any potential impact
                that such employment or activity may have on your working hours,
                performance, health and safety, compliance with the Working Time
                Regulations 1998, or any actual or potential conflict of
                interest.
              </p>
              <p className="p__tag">
                Nothing in this clause prevents you from undertaking additional
                employment or business activities unless the Company reasonably
                considers that such activities are incompatible with your
                duties, adversely affect your performance, create a conflict of
                interest, or otherwise prejudice the legitimate interests of the
                Company.
              </p>

              <h3>probationary period</h3>
              <p className="p__tag">
                Your employment is subject to a probationary period of six (6)
                months commencing on your start date and ending on{" "}
                <b>
                  {moment(
                    data.probationDate,
                    ["DD/MM/YYYY", "YYYY-MM-DD"],
                    true,
                  ).format("DD/MM/YYYY")}
                </b>
                .
              </p>
              <p className="p__tag">
                During your probationary period, your performance, conduct,
                attendance, timekeeping, suitability for the role and overall
                compatibility with the Company's standards and values will be
                assessed.
              </p>
              <p className="p__tag">
                The Company may hold formal or informal probationary review
                meetings during your probationary period, but reserves the right
                to make decisions regarding the outcome of your probation
                whether or not such meetings have taken place. The Company will
                confirm in writing when probation is successfully completed.
              </p>
              <p className="p__tag">
                The Company may, at its absolute discretion, confirm your
                probation has been passed, extend your probationary period for
                such period as it considers reasonable (once or on more than one
                occasion, to a max of 2 times), or terminate your employment.
              </p>
              <p className="p__tag">
                Any extension to your probationary period will be confirmed in
                writing and may include specific objectives or standards that
                you will be expected to achieve.
              </p>
              <p className="p__tag">
                Successful completion of your probationary period does not
                affect the Company's right to manage performance, conduct or
                capability at any stage during your employment. If you do not
                receive written confirmation, this does not necessarily mean
                that your probationary period has been successfully completed,
                and the Company reserves the right to extend your probationary
                period where appropriate.
              </p>
              <p className="p__tag">
                During your probationary period, and during any extension of it,
                the Company reserves the right not to apply its full
                disciplinary, capability and grievance procedures. Instead, the
                Company may follow such procedure as it considers reasonable in
                the circumstances.
              </p>

              <h3>employee training</h3>
              <p className="p__tag">
                The Company is committed to providing appropriate training to
                enable you to carry out your duties effectively and safely.
                During your employment, you may be required to undertake
                induction training, role-specific training, refresher training,
                compliance training and any other training the Company considers
                necessary for the performance of your role or to meet legal or
                operational requirements.
              </p>
              <p className="p__tag">
                You are required to attend, participate in and successfully
                complete all mandatory training within the timescales specified
                by the Company. This includes completing any online training
                modules, assessments or practical training as required.
              </p>
              <p className="p__tag">
                You must familiarise yourself with, and comply with, all Company
                policies, procedures and working practices relevant to your
                role. Where required, you must acknowledge that you have read
                and understood such policies and procedures.
              </p>
              <p className="p__tag">
                Where your role requires you to hold or maintain a licence,
                qualification or professional certification, you must ensure
                that it remains valid throughout your employment and immediately
                notify the Company if it expires, is suspended, revoked or
                becomes subject to any restriction.
              </p>
              <p className="p__tag">
                If you believe that you require additional training to perform
                your duties safely or effectively, you should notify your Line
                Manager as soon as reasonably practicable. Similarly, where the
                Company identifies a training requirement, you will be expected
                to fully participate in any training provided.
              </p>

              <h3>recovery of training costs</h3>
              <p className="p__tag">
                Where the Company agrees to fund external training,
                qualifications or professional courses that are not mandatory
                for your role, you may be required to enter into a separate
                Training Costs Agreement before the training commences.
              </p>
              <p className="p__tag">
                Where such an agreement is in place, and you leave the Company's
                employment or your employment is terminated for misconduct
                before the agreed repayment period has expired, the Company
                reserves the right to recover all or part of the training costs
                from any sums due to you, in accordance with the terms of the
                Training Costs Agreement and any applicable legal requirements.
              </p>

              <h3>remuneration</h3>
              <p className="p__tag">
                Your rate of pay will be{" "}
                <b>
                  {data.hourly} {data.salaryType}
                </b>
                , payable monthly in arrears by bank transfer into your
                nominated bank account. Payment is made anytime on the second
                Friday of each month by bank transfer into your nominated bank
                account in respect of all hours worked between the 1st and the
                last day of the previous calendar month. You will receive an
                itemised payslip in accordance with statutory requirements.
              </p>
              <p className="p__tag">
                Where your employment commences or ends part way through a pay
                period, your salary or wages will be calculated on a pro-rata
                basis.
              </p>
              <p className="p__tag">
                If you are an hourly-paid employee, all authorised additional
                hours worked will be paid at your normal hourly rate unless
                otherwise agreed in writing.
              </p>
              <p className="p__tag">
                Any overtime, additional payments or allowances are payable only
                where they have been authorised in advance by your Line Manager
                or another authorised manager.
              </p>
              <p className="p__tag">
                The Company may review your rate of pay from time to time. Any
                review does not imply an entitlement to an increase, and any
                increase will be entirely at the Company's discretion unless
                otherwise required by law or contractual agreement.
              </p>
              <p className="p__tag">
                If you are overpaid for any reason, including payroll,
                administrative or clerical error, the Company reserves the right
                to recover the overpayment from your future salary or wages, or
                from any other sums due to you, following consultation with you
                and in accordance with applicable legislation.
              </p>

              {!isStrathclyde && (
                <>
                  <br />
                  <br />
                </>
              )}

              <h3>deductions from pay</h3>
              <p className="p__tag">
                As a condition of your employment, you will be required to sign
                the Company's Deductions from Pay Agreement, which forms part of
                your contractual documentation.
              </p>
              <p className="p__tag">
                The Company is authorised to make deductions from your salary or
                wages where this is permitted by law or where you have provided
                your prior written agreement, including under the Deductions
                from Pay Agreement.
              </p>
              <p className="p__tag">
                Any uniform, equipment, keys, access cards, electronic devices
                or other property issued to you remain the property of the
                Company and must be returned in good condition (allowing for
                fair wear and tear) on request or upon the termination of your
                employment.
              </p>
              <p className="p__tag">
                Where Company property is not returned within the required
                timescale (5 days) and is returned damaged (other than through
                fair wear and tear), or requires replacement due to loss or
                negligence, the Company reserves the right to recover the
                reasonable replacement or repair costs in accordance with the
                Deductions from Pay Agreement.
              </p>
              <p className="p__tag">
                Further details are contained within the Company's Deductions
                from Pay Agreement and related policies, copies of which are
                available from the HR Department upon request.
              </p>
              <p className="p__tag">
                In the event of any inconsistency between this Agreement and the
                Deductions from Pay Agreement, the Deductions from Pay Agreement
                shall prevail.
              </p>

              <h3>collective agreements</h3>
              <p className="p__tag">
                There are no collective agreements in force that directly affect
                your terms and conditions of employment.
              </p>

              <h3>annual leave and public/bank holidays</h3>
              <p className="p__tag">
                The Company's holiday year runs from 1st January to 31st
                December.
              </p>
              <p className="p__tag">
                Your annual holiday entitlement is 5.6 weeks' paid holiday per
                holiday year, inclusive of public and bank holidays. Your
                entitlement will be calculated on a pro-rata basis where you
                commence or terminate employment part way through the holiday
                year or where you work part-time.
              </p>
              <p className="p__tag">
                Holiday requests must be submitted in accordance with the
                Company's holiday booking procedures and approved by your Line
                Manager before any leave is taken. The Company reserves the
                right to refuse, postpone or cancel holiday requests where this
                is reasonably necessary to meet the operational requirements of
                the business.
              </p>
              <p className="p__tag">
                Holiday requests exceeding three consecutive working weeks will
                not normally be approved. If you wish to take more than three
                consecutive working weeks of annual leave, you must obtain the
                prior written approval of both your Line Manager, HR Department,
                and the Senior Management Team before making any travel or
                accommodation arrangements.
              </p>
              <p className="p__tag">
                The Company may identify certain periods during the year when
                annual leave will be restricted or will not normally be approved
                due to operational requirements. This will normally include the
                month of December and the first two weeks of January, although
                other peak trading periods, stocktakes, business-critical events
                or operational demands may also be designated from time to time.
                Wherever reasonably practicable, employees will be notified of
                such restricted periods in advance.
              </p>
              <p className="p__tag">
                Due to the nature of the Company's business, you may be required
                to work on public or bank holidays. Where you are required to
                work on Christmas Day or New Year's Day, you will be paid at
                double your normal hourly rate.
              </p>
              <p className="p__tag">
                Annual leave should normally be taken during the holiday year in
                which it accrues. Unless otherwise required by law, any untaken
                holiday entitlement will not be carried forward into the next
                holiday year without the Company's prior written agreement.
              </p>
              <p className="p__tag">
                The Company reserves the right to specify when annual leave is
                to be taken, subject to the relevant statutory notice
                requirements.
              </p>
              <p className="p__tag">
                On termination of your employment, payment will be made for any
                accrued but untaken statutory holiday entitlement. Where you
                have taken more holiday than you have accrued at the date your
                employment ends, the Company reserves the right to deduct the
                appropriate amount from any salary, wages or other payments due
                to you, in accordance with the Deductions from Pay Agreement and
                applicable legislation.
              </p>

              <h3>sickness, absence, and statutory sick pay</h3>
              <p className="p__tag">
                If you are unable to attend work due to sickness or injury, you
                must notify your Line Manager (or another designated manager)
                personally as soon as reasonably practicable and, at least six
                hours before your normal start time on the first day of absence.
                You must explain the reason for your absence and, where
                possible, indicate the expected duration.
              </p>
              <p className="p__tag">
                You must keep the Company informed of your ongoing absence and
                maintain regular contact in accordance with the Company's
                Sickness Absence Policy.
              </p>
              <p className="p__tag">
                Unreasonable failure to comply with the Company's sickness
                absence reporting procedures may be dealt with under the
                Company's disciplinary procedure.
              </p>
              <p className="p__tag">
                You will be required to provide evidence of your incapacity for
                work in accordance with statutory requirements and the Company's
                procedures. This may include self-certification for the first
                seven calendar days of absence and a Fit Note (commonly known as
                'sick note') or other appropriate medical evidence thereafter.
              </p>
              <p className="p__tag">
                The Company does not operate a contractual sick pay scheme.
                Subject to meeting the qualifying conditions, you may be
                entitled to Statutory Sick Pay (SSP) in accordance with current
                legislation.
              </p>
              <p className="p__tag">
                The Company reserves the right, where considered reasonable, to
                obtain a medical report from your GP or another medical
                practitioner (subject to your consent where required by law).
                The Company may also require you to attend a return-to-work
                meeting following any period of sickness absence.
              </p>
              <p className="p__tag">
                Further details of the Company's sickness absence reporting
                procedures are set out in the Employee Handbook.
              </p>

              <h3>family leave</h3>
              <p className="p__tag">
                The Company recognises and supports employees' statutory rights
                in relation to maternity, paternity, adoption, shared parental,
                parental, neonatal care and other family-related leave.
              </p>
              <p className="p__tag">
                Subject to meeting the relevant statutory eligibility criteria,
                you may be entitled to statutory leave and pay in accordance
                with the legislation in force at the time your entitlement
                arises.
              </p>
              <p className="p__tag">
                Employees are required to notify the Company of any pregnancy,
                adoption placement or other family leave event as soon as
                reasonably practicable and to provide any information or
                documentation required to establish their entitlement.
              </p>
              <p className="p__tag">
                Further details regarding eligibility, notification
                requirements, statutory payments and the procedures to be
                followed are set out in the Company's Policies and will be
                provided by the HR Department upon request.
              </p>

              <h3>capability and disciplinary procedures</h3>
              <p className="p__tag">
                The Company's Capability and Disciplinary Procedures are set out
                in the Employee Handbook. These procedures do not form part of
                your contract of employment and may be amended by the Company
                from time to time.
              </p>
              <p className="p__tag">
                The Company reserves the right to depart from, vary or omit any
                stage of its procedures where it considers it appropriate to do
                so, subject to applicable law.
              </p>

              <h3>capability/disciplinary appeal procedure</h3>
              <p className="p__tag">
                If you are dissatisfied with any formal disciplinary or
                capability decision, you may appeal in writing to the HR
                Department within five days of receiving the decision, stating
                the grounds of your appeal.
              </p>
              <p className="p__tag">
                Appeals will be considered in accordance with the Company's
                Appeal Procedure, details of which are contained in the Employee
                Handbook.
              </p>

              <h3>grievance procedure</h3>
              <p className="p__tag">
                If you have a grievance relating to your employment, you should
                raise it as soon as reasonably practicable with your Line
                Manager or the HR Department.
              </p>
              <p className="p__tag">
                Grievances will be dealt with in accordance with the Company's
                Grievance Procedure, details of which are contained in the
                Employee Handbook.
              </p>
              <p className="p__tag">
                The Company's Grievance Procedure does not form part of your
                contract of employment and may be amended from time to time.
              </p>

              <h3>termination of employment</h3>
              <p className="p__tag">
                Either you or the Company may terminate your employment by
                giving the notice set out below.
              </p>
              <p className="p__tag">
                If you terminate your employment without giving or working your
                full contractual notice, the Company reserves the right to
                deduct from any salary, wages, or other payments due to you an
                amount equal to any additional costs reasonably incurred by the
                Company in covering your duties during the notice period not
                worked. Such deductions will only be made where permitted by law
                and in accordance with the Deductions from Pay Agreement signed
                by you at the commencement of your employment.
              </p>
              <p className="p__tag">
                Upon the termination of your employment, or at any time on
                request, you must immediately return all Company property in
                your possession or control, including (but not limited to) keys,
                access cards, uniforms, equipment, electronic devices,
                documents, records and any confidential information belonging to
                the Company.
              </p>
              <p className="p__tag">
                Your obligations relating to confidentiality, data protection,
                intellectual property (where applicable) and any
                post-termination restrictions contained within this Agreement
                will continue after your employment ends where relevant.
              </p>

              <h3>notice of termination to be given by employer</h3>
              <p className="p__tag">
                Less than one month's continuous service: No notice
              </p>
              <p className="p__tag">
                One month but less than two years' continuous service: one
                week's notice
              </p>
              <p className="p__tag">
                Two or more years' continuous service: One week's notice for
                each completed year of service, up to a maximum of twelve weeks
              </p>
              <p className="p__tag">
                Nothing in this clause prevents the Company from giving a longer
                period of notice where required by this Agreement or by law.
              </p>
              <p className="p__tag">
                Notwithstanding the contractual notice provisions set out in
                this Agreement, the Company and the employee may mutually agree
                in writing to reduce or waive all or part of the applicable
                notice period. Any such agreement will be entirely at the
                Company's discretion and must be confirmed in writing by an
                authorised representative of the Company. Unless and until such
                written agreement has been reached, the full contractual notice
                period will continue to apply.
              </p>

              <h3>notice of termination to be given by employee</h3>
              <p className="p__tag">
                Less than one month's continuous service: No notice
              </p>
              <p className="p__tag">
                One month's continuous service or more:{" "}
                <b>{data.noticePeriod}</b>
              </p>

              <h3>pay in lieu of notice</h3>
              <p className="p__tag">
                The Company reserves the right, at its absolute discretion, to
                terminate your employment immediately by making a payment in
                lieu of all or part of your contractual notice period. Any such
                payment will be subject to the applicable deductions for tax and
                National Insurance contributions.
              </p>
              <p className="p__tag">
                The Company also reserves the right to place you on garden leave
                for all or part of your notice period where it considers this
                appropriate.
              </p>

              <h3>pension and pension scheme</h3>
              <p className="p__tag">
                The Company operates a workplace pension scheme in accordance
                with its legal obligations under the applicable pension
                legislation.
              </p>
              <p className="p__tag">
                If you meet the eligibility criteria for automatic enrolment,
                you will be enrolled into the Company's workplace pension scheme
                in accordance with the law. Details of the pension scheme,
                including contribution rates and your rights in relation to
                membership, will be provided separately – should you be
                eligible.
              </p>
              <p className="p__tag">
                If you are not eligible for automatic enrolment, you may still
                have the right to join or opt into the Company's workplace
                pension scheme in accordance with the applicable legislation.
              </p>
              <p className="p__tag">
                The Company reserves the right to change its pension provider or
                amend the pension arrangements from time to time, provided that
                it continues to comply with its legal obligations.
              </p>

              <h3>variation of terms</h3>
              <p className="p__tag">
                The Company reserves the right to make reasonable amendments to
                non-contractual policies and procedures from time to time. Any
                variation to the Employee's contractual terms and conditions
                will only be effective if confirmed in writing by the Company.
                No oral statement or prior course of dealing shall operate to
                vary or amend the terms of this Agreement. Nothing in this
                clause permits unilateral variation of contractual terms.
              </p>

              <h3>entire agreement</h3>
              <p className="p__tag">
                This Agreement, together with any documents expressly
                incorporated into it (including, without limitation, any
                Deduction from Pay Agreement, Uniform Agreement, and any other
                expressly incorporated documents, constitutes the entire
                agreement between the parties and supersedes all prior
                discussions, correspondence, negotiations, understandings, or
                agreements, whether written or oral, relating to the Employee's
                employment. The Employee acknowledges that they have not entered
                into this Agreement in reliance on any statement or
                representation not expressly set out in it, save in the case of
                fraudulent misrepresentation.
              </p>

              <h3>governing law and jurisdiction</h3>
              <p className="p__tag">
                This Agreement, and any dispute or claim arising out of or in
                connection with it or its subject matter or formation (including
                non-contractual disputes or claims), shall be governed by and
                construed in accordance with the laws of Scotland. The parties
                irrevocably agree that the court of Scotland shall have
                exclusive jurisdiction to settle any such dispute or claim.
              </p>

              <br />
              <p className="p__tag" style={{ fontWeight: "bold" }}>
                For and on behalf of the Employer:
              </p>
              <div className="signature">
                <img
                  src="https://staff.racetrackpitstop.co.uk/wp-content/uploads/2021/10/shamly_sig.png"
                  alt="Director signature"
                />
                <p className="p__tag">{moment().format("DD/MM/YYYY")}</p>
              </div>

              <p className="p__tag">
                I acknowledge receipt of this statement and agree that, for the
                purpose of the Working Time Regulations, any applicable
                entitlements and provisions constitute a Relevant Agreement.
              </p>
              <div className="signature">
                <p className="p__tag" style={{ fontWeight: "bold" }}>
                  Employee signature:
                </p>

                <SignatureCanvas
                  penColor="black"
                  canvasProps={{ className: "sigCanvas" }}
                  ref={(ref) => {
                    setSignature(ref);
                  }}
                />
                <p className="p__tag">{moment().format("DD/MM/YYYY")}</p>
                <Button
                  sx={{ marginBottom: "2%" }}
                  color="error"
                  onClick={() => signature.clear()}
                >
                  Clear Signature
                </Button>
                {errorAlert ? (
                  <Alert severity={severity}>{message}</Alert>
                ) : (
                  <></>
                )}

                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  color="error"
                  className="send__button"
                  onClick={() => sign()}
                  id="sign__btn"
                >
                  Send
                </Button>

                {tick ? <Tick /> : <></>}
              </div>
            </section>
          </>
        ) : (
          <>
            <img src={Logo} alt="logo" />
            <h2>Can not find any details for this individual.</h2>
          </>
        )}
      </main>
      {!noDetails ? <Footer /> : <></>}
    </>
  );
}
